import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import ModalRiwayatIuran from 'components/pages/modal/participant/peserta/riwayatIuran'
import ModalRiwayatKlaim from 'components/pages/modal/participant/peserta/riwayatKlaim'

class DaftarPesertaPasif extends Component {
  constructor(props) {
    super(props)

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.dataGridRef = React.createRef()
    this.modalRiwayatIuranRef = React.createRef()
    this.modalRiwayatKlaimRef = React.createRef()

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Riwayat Iuran',
            hint: 'edit',
            onClick: (e) => {
              this.modalRiwayatIuranRef.current.show()
              this.modalRiwayatIuranRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Riwayat Klaim',
            hint: 'edit',
            onClick: (e) => {
              this.modalRiwayatKlaimRef.current.show()
              this.modalRiwayatKlaimRef.current.retrieveData(e.row.data)
            },
          },
        ],
      },
      {
        dataField: 'no',
        caption: 'No',
        cellRender: (e) => {
          return e.rowIndex + 1
        },
      },
      {
        dataField: 'pesertaPasif',
        caption: 'Peserta Pasif',
        alignment: 'center',
        columns: [
          {
            dataField: 'nik',
            caption: 'NIK',
          },
          {
            dataField: 'fullName',
            caption: 'Nama Karyawan',
          },
          {
            dataField: 'pensiunDate',
            caption: 'Tanggal Pensiun',
            dataType: 'date',
            format: 'dd MMM yyyy',
          },
          {
            dataField: 'pensiunTypeName',
            caption: 'Jenis Pensiun',
          },
          {
            dataField: 'productName',
            caption: 'Produk Dana Pensiun',
          },
        ],
      },
      {
        dataField: 'manfaatPensiun',
        caption: 'Manfaat Pensiun',
        alignment: 'center',
        columns: [
          {
            dataField: 'nominalMpSekaligus',
            caption: 'Nominal MP Sekaligus',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'nominalAnuitas',
            caption: 'Nominal Anuitas',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'nominalBerkala',
            caption: 'Nominal Berkala',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
        ],
      },
      {
        dataField: 'manfaatPensiunLain',
        caption: 'Manfaat Pensiun Lain',
        alignment: 'center',
        columns: [
          {
            dataField: 'mpLain',
            caption: 'MP Lain',
          },
          {
            dataField: 'mpLainValue',
            caption: 'Nilai MP Lain',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
        ],
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Daftar Peserta Pasif</h2>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI={`wp/pesertas/pasif?akunStatusId.in=2&akunStatusId.in=3&akunStatusId.in=4&akunStatusId.in=5&akunStatusId.in=7&akunStatusId.in=10&participantId.equals=${this.participantId}`}
          insertAPI="wp/pesertas/pasif"
          updateAPI="wp/pesertas/pasif"
          deleteAPI="wp/pesertas/pasif"
          backendserver={process.env.REACT_APP_BACKEND_CORE}
          remoteOperations={true}
          // useArraySource={true}
          // ArraySourceData={this.loadDummyData}

          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          exportExcel={false}
          exportFileName={'Daftar Peserta Pasif'}
          allowExportSelectedData={true}
          selection={'multiple'}
          showBorders={true}
          paging={true}
          defaultPageSize={10}
          height={'80vh'}
          //bagian konfigurasi popup saat insert dan edit record
          popupTitle={'Daftar Peserta Pasif'}
          popupWidth={700} //masukan dalam ukuran pixel
          popupHeight={500} //masukkan dalam ukuran pixel
          popupFormLabelLocation="left" //accepted value = top, left, right
          popupFormMinColWidth={300} // minimum lebar kolom
          popupFormColCount={3} //jumlah kolom pada form
          //akhir bagian konfigurasi popup

          ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
          ColumnFixing={true} // set false agar kolom tidak dapat di freeze
          FilterRow={true} // set false untuk mematikan fitur filter
          ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
          SummaryConfiguration={this.summary}
          store={this.props.store} // jangan di edit edit
        />
        <ModalRiwayatIuran
          ref={this.modalRiwayatIuranRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
        <ModalRiwayatKlaim
          ref={this.modalRiwayatKlaimRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
      </div>
    )
  }
}

export default DaftarPesertaPasif
